module.exports = __webpack_public_path__ + "img/China.d67bb365.png";